<template>
  <!-- 用户端详情 -->
  <div class="discovery_details_info">
    <headerTitle :item="formData" :itemId="formData.id" v-if="formData.id" />
    <div v-if="formData.status!='REJECTED' && formData.isDeleted=='n'">
      <!-- <shareBtn/> -->
      <!-- <headerTitle :item="formData" :itemId="formData.id"/> -->
      <productDetail
        :productData="productData"
        @imageIndex="onGetImageIndex"
        v-if="$route.query.atlasId"
      />
      <swipeInfo :item="formData.fileList" :bees="formData" v-else />
      <commodityCard :item="formData" v-if="formData && formData.discoverType=='NORMAL'" />
      <prefer v-if="formData.discountComerMarkVO&&formData.discountComerMarkVO.activityId" :prefer="formData.discountComerMarkVO" :itemGoodsId="formData.id"></prefer>
      <goodsActivity v-if="formData.goodsActivityInfo" :info="formData.goodsActivityInfo"></goodsActivity>
      <shopperItem :item="productData" :beesInfo="beesInfo" v-if="$route.query.atlasId" />
      <shopperItem :item="formData" :beesInfo="beesInfo" v-else />
      <BranchItem  :goodsList="formData.beesOtherDiscover" :beesUserId="formData.beesUserId" @callbackFun="changeRouteFun"/>
      <mixedRecoListdata ref="mixedReco" :headerStatus="true" :showStatus="true" :mixedRecoParams="mixedRecoParams"></mixedRecoListdata>
      <shareItem class="index-bottom-share"
        :beesInfo="beesInfo"
        v-if="formData.id"
        :item="formData"
        :likeCount="formData.likeCount"
        :productData="productData"
        :isSingle="$route.query.sessionId ? 'n' : 'y'"
      />
    </div>
    <div v-if="formData.status=='REJECTED' || formData.isDeleted=='y'">
      <emptyItem />
    </div>
    <van-dialog :beforeClose="beforeClose" v-model="show" show-cancel-button cancel-button-text="返回" confirm-button-text="查看其它商品" confirm-button-color="#F8A651">
      <div class="no_goods_down">
        <img src="@/assets/atlas/mi.png" />
        <p>该商品库存不足，已下架</p>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import headerTitle from "./components/headerTitle";
import swipeInfo from "./components/swipeInfo";
import shareItem from "./components/shareItem";
import shopperItem from "./components/shopperItem";
import commodityCard from "./components/commodityCard";
import emptyItem from "./components/emptyItem";
import shareBtn from "./components/shareBtn";
import http from "@/utils/axios";
import utils from "@/utils/common";
import productDetail from "@/components/atlas/productDetail";
import mixedRecoListdata from '@/components/mixedReco/mixedRecoListdata';
import BranchItem from './components/branchItem';
import prefer from './components/prefer';
import goodsActivity from './components/goodsActivity';
export default {
  data() {
    return {
      show:false,
      formData: {},
      beesInfo: {},
      productData: {},
      mixedRecoParams: {},
      chooseImageUrl: "",
      productSetTimer: null,
      goodsListForBranch:[]
    };
  },
  methods: {
    beforeClose(action, done){
      if(action =='confirm'){
        let brandchId = this.formData.branchId ? this.formData.branchId : this.formData.brandId;
        if (brandchId) {
          let url = location.origin + "/h5user/brandindex?brandId=" + brandchId;
          utils.jumpToNewPage({
            url: url,
            noTitle: "1",
            action:{tm:"4090100",tp:{branchId:parseInt(brandchId)}}
          });
        }
      }else if(action =='cancel'){
        utils.goBack()
      }
      done(false)
      
    },
    getDetails(flag) {
      let discoverId =
        this.$route.query && this.$route.query.id
          ? this.$route.query.id
          : this.$route.query.discoverId;
      http({
        url: "/discover/appbees/discover/content/detail",
        method: "POST",
        parmes: {
          discoverId: discoverId,
          beesId: this.$route.query.beesUserId || "",
          nimname: this.$route.query.sessionId || ""
        }
      }).then(rps => {
        if (rps.code == 200) {
          this.show = rps.data.isHidden;
          flag && (this.$root.$el.scrollTop = 0);
          clearInterval(this.productSetTimer);
          rps.data.surplusTime = {
            day: "00",
            hour: "00",
            minute: "00",
            second: "00"
          };
          if(rps.data.discountComerMarkVO&&rps.data.discountComerMarkVO.endTime) {
            this.setDTimeOut(rps.data.discountComerMarkVO.endTime)
          }
            
          this.formData = rps.data;
          this.mixedRecoParams = rps.data.recommends ? rps.data.recommends : {}
          this.$loading.hide();
        }
      });
    },
    setDTimeOut(timeLong) {
      this.productSetTimer = setInterval(function() {
        var nowsTimeLong = new Date().valueOf();
        var surplusTimeLong = timeLong - nowsTimeLong;
        var day = Math.floor(surplusTimeLong / (1000 * 60 * 60 * 24));
        var hour = Math.floor(
          (surplusTimeLong / (1000 * 60 * 60)) % 24
        );
        var minute = Math.floor((surplusTimeLong / (1000 * 60)) % 60);
        var second = Math.floor((surplusTimeLong / 1000) % 60);
        var surplusTime = {
          day: day < 9 ? "0" + day : day,
          hour: hour < 9 ? "0" + hour : hour,
          minute: minute < 9 ? "0" + minute : minute,
          second: second < 9 ? "0" + second : second
        };
        if (surplusTimeLong <= 0) {
          clearInterval(this.productSetTimer);
        }
        rps.data.surplusTime = surplusTime;
      }, 1000);
    },
    onGetImageIndex: function(event) {
      this.chooseImageUrl = this.productData.fileList[event.imageIndex].fileUrl;
    },
    onAtlasProductDetail: function() {
      http({
        url: "discover/appbees/discoveratlas/content/detail",
        method: "post",
        parmes: {
          atlasId: this.$route.query.atlasId,
          id: this.$route.query.discoverId,
          beesId: this.$route.query.beesUserId
        }
      }).then(res => {
        if (res.code == 200) {
          this.productData = res.data;
          this.mixedRecoParams = res.data.recommends ? res.data.recommends : {}
          console.log(res.data)
          this.chooseImageUrl = this.productData.fileList[0].fileUrl;
        }
      });
      let gioPrmes = {
        userId: '',
        functionName_var: "推荐阅读",
        foundID_var: this.$route.query.discoverId,
        imageSet_var:this.$route.query.atlasId,
        userName_var: '',
        storeName_var: this.productData.branchName,
        storeID_var: this.productData.branchId,
        position_var:this.$route.query.index
      };
      if (localStorage.getItem("userInfo")) {
        let userInfo = JSON.parse(localStorage.getItem("userInfo"));
        gioPrmes.userId = userInfo.userId;
        gioPrmes.userName_var = userInfo.nickname;
      }
      gio("track", "userImageProductRecommend_var", gioPrmes); 
    },
    changeRouteFun(val){
      this.$loading.show();
      let query = this.$route.query;
      query.id= val;
      this.$router.replace({ query: query });
      this.getDetails('reload');
    },
    /**
     * 获取图片列表中最高一张图片的高度
     */
    // getImagesMaxHeight(imageOriginWidth, imageOriginHeight) {
    //   if(
    //     isNaN(imageOriginWidth) ||
    //     isNaN(imageOriginHeight) ||
    //     imageOriginWidth <= 0 ||
    //     imageOriginHeight <= 0
    //   ) {
    //     return 'auto'
    //   }
    //   // debugger
    //   const WINDOW_WIDTH = document.documentElement.clientWidth || document.body.clientWidth

    //   //屏幕比例
    //   const SCREEN_SCALE = WINDOW_WIDTH / 750

    //   //原始图片比例
    //   const IMAGE_SCALE = imageOriginHeight / imageOriginWidth

    //   // 1e-4 等 0.0001 算出来的高度可能是 499.9999999 所以加上1e-4
    //   const EPS = 1e-4

    //   //图片在屏幕显示最大高度
    //   const IMAGE_MAX_HEIGHT = Math.floor(1000 * SCREEN_SCALE + EPS)

    //   //图片在屏幕显示的高度
    //   const IMAGE_HEIGHT = Math.floor(WINDOW_WIDTH * IMAGE_SCALE + EPS)

    //   return (IMAGE_HEIGHT > IMAGE_MAX_HEIGHT ? IMAGE_MAX_HEIGHT : IMAGE_HEIGHT) + 'px'
    // }
  },
  components: {
    headerTitle,
    shareItem,
    shopperItem,
    commodityCard,
    emptyItem,
    swipeInfo,
    shareBtn,
    productDetail,
    mixedRecoListdata,
    BranchItem,
    prefer,
    goodsActivity
  },
  created() {
    this.getDetails();
    if (this.$route.query.atlasId) {
      this.onAtlasProductDetail();
    }
    let discoverId =
      this.$route.query && this.$route.query.id
        ? this.$route.query.id
        : this.$route.query.discoverId;
    utils.nativeMethod({ tm: "4000101", tp: { activityID_evar: discoverId } });
    console.log(this.$refs)
      this.$refs.mixedReco && this.$refs.mixedReco.onGetMixedRecoData()
  }
};
</script>
<style lang="less" scoped>
.discovery_details_info {
  margin-bottom: 100px;
}
.index-bottom-share{
  z-index: 100;
}
.no_goods_down{
  text-align: center;
  padding: 20px 0;
  img{
    
    width: 160px;
    height: 160px;
    object-fit: cover;
  }
  p{
    font-size: 28px;
    color: #333;
    padding: 30px 0;
  }
}
</style>